import React from 'react';

const SubmitButton = ({
  isLoading,
  disabled,
  children,
  icon: Icon,
  className = '',
  fullWidth = true, // Add fullWidth prop with default true for backwards compatibility
  ...props
}) => {
  const isDisabled = isLoading || disabled;

  const baseClasses = "py-3 px-4 rounded-xl flex items-center justify-center font-medium text-white shadow-md transition-all";
  
  const widthClass = fullWidth ? "w-full" : "w-auto";
  const activeClasses = "bg-gradient-to-r from-primary-600 to-primary-700 hover:from-primary-700 hover:to-primary-800 hover:shadow-lg";
  const disabledClasses = "bg-gray-400 cursor-not-allowed";

  const combinedClassName = `${baseClasses} ${widthClass} ${isDisabled ? disabledClasses : activeClasses} ${className}`;

  return (
    <button
      type="submit"
      disabled={isDisabled}
      className={combinedClassName}
      {...props}
    >
      {isLoading ? (
        <span className="flex items-center">
          <svg className="animate-spin -ml-1 mr-2 h-5 w-5 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
            <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
            <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
          </svg>
          Processing...
        </span>
      ) : (
        <span className="flex items-center">
          {children}
          {Icon && <Icon className="ml-2 h-5 w-5" />}
        </span>
      )}
    </button>
  );
};

export default SubmitButton;